import { render } from "./AddPanelBasic.vue?vue&type=template&id=5bedf2fe&scoped=true"
import script from "./AddPanelBasic.vue?vue&type=script&lang=js"
export * from "./AddPanelBasic.vue?vue&type=script&lang=js"

import "./AddPanelBasic.vue?vue&type=style&index=0&id=5bedf2fe&lang=css&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bedf2fe"],['__file',"src/assets/js/components/panels/forms/AddPanelBasic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bedf2fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bedf2fe', __exports__)) {
    api.reload('5bedf2fe', __exports__)
  }
  
  module.hot.accept("./AddPanelBasic.vue?vue&type=template&id=5bedf2fe&scoped=true", () => {
    api.rerender('5bedf2fe', render)
  })

}


export default __exports__